/** With `<base href="/">`, `href="#id"` resolves to `/#id` (home). Use current path + hash for the real URL. */
export function samePageHashHref(pathname: string, hash: string): string {
  const base = pathname && pathname !== "" ? pathname : "/";
  const h = hash.startsWith("#") ? hash : `#${hash}`;
  return `${base}${h}`;
}

/**
 * Programmatic `behavior: "smooth"` often stutters on mobile (fights compositor momentum).
 * Prefer instant scroll on coarse pointers and when the user asked for reduced motion.
 */
export function scrollIntoViewForPageNavigation(
  element: Element,
  options: { block?: ScrollLogicalPosition } = {},
): void {
  const block = options.block ?? "start";
  let instant = false;
  if (typeof globalThis.matchMedia === "function") {
    const mq = globalThis.matchMedia.bind(globalThis) as typeof window.matchMedia;
    instant = mq("(prefers-reduced-motion: reduce)").matches || mq("(pointer: coarse)").matches;
  }
  element.scrollIntoView({ behavior: instant ? "auto" : "smooth", block });
}

export function scrollToElementByHash(hash: string): void {
  const id = hash.startsWith("#") ? hash.slice(1) : hash;
  const el = document.getElementById(id);
  if (el) scrollIntoViewForPageNavigation(el);
}
